import { render, staticRenderFns } from "./groups-page.vue?vue&type=template&id=35c26bce&scoped=true&lang=pug&"
import script from "./groups-page.vue?vue&type=script&lang=js&"
export * from "./groups-page.vue?vue&type=script&lang=js&"
import style0 from "./groups-page.vue?vue&type=style&index=0&id=35c26bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c26bce",
  null
  
)

export default component.exports